import React, { Suspense, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Routes from './Routes/Routes';
import Loader from './components/Common/Loader/Loader';
import { IInitialState } from './types/initialState.types';
import Sentry from './utils/sentry';
import Alert from './components/Common/Alert/Alert';
import AlertV1 from './components/Common/v1/Alert';

import 'react-tooltip/dist/react-tooltip.css';

function App() {
  const userIdentityData = useSelector(
    (state: IInitialState) => state.auth.userIdentityData
  );
  const { version } = useSelector((state: IInitialState) => state?.alert);

  useEffect(() => {
    if (userIdentityData?.user_auth_id) {
      Sentry.setUser({
        email: userIdentityData.email,
        full_name: userIdentityData.name,
        user_name: userIdentityData.username,
        user_role: userIdentityData.user_role,
      });
    }
  }, [userIdentityData?.user_auth_id]);

  return (
    <Suspense fallback={<Loader />}>
      <Routes />
      {version === 'v1' ? <AlertV1 /> : <Alert />}
    </Suspense>
  );
}

export default App;
